<template>
  <div class="h-auto pb-20 lg:w-[99%] mx-auto">
    <h1 class="font-display text-primary-text font-bold text-basicTitle pb-9 ltr:maxMd:pl-5 rtl:maxMd:pr-5 mt-20 md:mt-0">
      {{ $t('copy_trading').tTitle() }}
    </h1>
    <div class="flex gap-[30px] flex-col xl:flex-row mx-2 md:mx-0 mb-20 lg:mb-28">
      <div class="w-full xl:w-[340px] h-auto xl:h-[917px] bg-gray-900 rounded-lg flex flex-col xl:justify-center xl:items-center px-5 xl:px-0 py-16 xl:py-0 shrink-0">
        <p class="text-[40px] leading-[50px] font-bold text-white mb-6 xl:mb-5 max-w-80 xl:max-w-[240px] xl:mx-auto xl:text-center">
          {{ $t('copy_trading_title') }}
        </p>
        <p class="text-base leading-[26px] xl:max-w-[250px] xl:mx-auto mb-9 text-white xl:text-center">{{ $t('copy_trading_description') }}</p>
        <div class="flex xl:block gap-4 xl:gap-2">
          <a
            href="https://social-trading.plexytrade.com/portal/registration/provider"
            target="_blank"
            class="h-[50px] w-[190px] rounded-md flex justify-center items-center bg-blue text-white text-base font-bold mb-2"
            :class="{ 'w-[220px] text-sm lg:text-base': Language=='es' }"
          >
            {{ $t('become_a_provider') }}
          </a>
          <a
            href="https://social-trading.plexytrade.com/portal/login"
            target="_blank"
            class="h-[50px] w-[125px] lg:w-[190px] rounded-md flex justify-center items-center bg-gray-900 text-white text-base font-bold mb-2 border border-white"
            :class="{ 'w-[125px] lg:w-[220px] text-sm lg:text-base': Language=='es' }"
          >
            {{ $t('login_copy_trading') }}
          </a>
        </div>
      </div>
      <div class="w-full xl:w-calc4 xl:h-[917px]">
        <div class="-mt-3">
          <sub-menu :routes="routes" :customClass="'copyTradingSubmenu'"></sub-menu>
          <div class="min-h-[855px] lg:min-h-min lg:h-[855px] bg-white dark:bg-opacity-10 rounded-lg border border-divider mt-[88px] lg:mt-3 mx-0">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SubMenu from '@/components/SubMenu.vue'

export default {
  data() {
    return {
      title: this.$t('copy_trading'),
      routes: this.getRoutes(),
    }
  },
  components: {
    SubMenu,
  },
  watch: {
    Language() {
      this.updateRoutesAndTitle()
    },
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {},
  methods: {
    getRoutes() {
      return [
        { path: '/copy-trading', title: this.$t('all_providers').tTitle() },
        { path: '/copy-trading/highest-return-providers', title: this.$t('highest_return_providers').tTitle() },
        { path: '/copy-trading/top-risk-adjusted-return', title: this.$t('top_risk_adjusted_return').tTitle() },
        { path: '/copy-trading/most-heavily-invested', title: this.$t('most_heavily_invested').tTitle() },
      ]
    },
    updateRoutesAndTitle() {
      this.title = this.$t('copy_trading').tTitle()
      this.routes = this.getRoutes()
    },
  },
}
</script>
<style>
.copyTradingSubmenu {
  @apply !mt-[-86px] px-5 lg:px-0;
}

.copyTradingSubmenu .submenubar{
  @apply !relative !bg-transparent
}

.copyTradingSubmenu #sub-menu-items {
  @apply !relative !top-auto !bg-transparent pl-0 l150:w-auto l150:max-w-[740px] l150:overflow-x-auto 2xl:w-max 2xl:overflow-x-hidden;
}

.copyTradingSubmenu .sub-menu-item {
  @apply w-max;
}

.copyTradingSubmenu #item .grid div {
  @apply w-max first:ml-0;
}

html[lang="es"] .copyTradingSubmenu-desktop #item .grid div{
  @apply text-[13px] min-w-fit
}
</style>
